// Include SCSS
import '../scss/main.scss';

jQuery(function($) {

    function prep_post_lists() {

        // console.log('running prep_post_lists()');
        
        $('body.properties .elementor-widget-posts article.properties').each(function() {

            let article_wrapper = $(this);
            let property_status_el = $(this).find('.property-status-el');
            let property_status = $(property_status_el).data('property-status');

            $(article_wrapper).data('property-status', property_status);
        });
    }

    function prep_post_lists_observer() {

        // Process our pre-existing properties
        prep_post_lists();

        // The node to be monitored
        var target = $('body.properties .elementor-posts')[0];

        // Create an observer instance
        var observer = new MutationObserver(function( mutations ) {
            mutations.forEach(function( mutation ) {
                var newNodes = mutation.addedNodes; // DOM NodeList
                if( newNodes !== null ) { // If there are new nodes added
                    
                    // console.log('DOM changed, we have new properties. Need to do something');

                    setTimeout(function(){

                        // Process our new properties
                        prep_post_lists();

                    }, 2000);//wait 2 seconds
                }
            });    
        });

        // Configuration of the observer:
        var config = { 
            attributes: true, 
            childList: true, 
            characterData: true 
        };
        
        // Pass in the target node, as well as the observer options
        if ($(target).length) {
            observer.observe(target, config);
        }
        
        // // Later, you can stop observing
        // observer.disconnect();
    }

	/*
	 *
	 *	Place items in here to have them run after the Dom is ready
	 *
	 */
	$(document).ready(function() {

        // Make all External Links and PDF's open in a new Tab
        var host = new RegExp('/' + window.location.host + '/');
        $('a').each(function() {
            if (
                (!host.test(this.href) &&
                    this.href.slice(0, 1) != '/' &&
                    this.href.slice(0, 1) != '#' &&
                    this.href.slice(0, 1) != '?') ||
                this.href.indexOf('.pdf') > 0
            ) {
                $(this).attr({
                    target: '_blank',
                    rel: 'noopener'
                });
            }
        });

        // Swiper for the properties single
        const swiper = new Swiper('body.single-properties .swiper', {
            direction: 'horizontal',
            loop: true,
            slidesPerView: 'auto',
            loopedSlides: $('body.single-properties .swiper .swiper-slide').size(),
            spaceBetween: 0,
            initialSlide: 0,
            centeredSlides: true,
            simulateTouch: true,
            speed: 300,
        
            // Autoplay
            autoplay: {
                delay: 5000,
            },

            // autoplay: false,

            // If we need pagination
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true
            },
        
            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        
            // And if we need scrollbar
            scrollbar: false,
        });

        // post-load
        $('body').on('post-load', function() {
            console.log('posts have been loaded');
        });

        // prep_post_lists();
        prep_post_lists_observer();

        if ($('body.recent-closings').length > 0)
        {
            $(document).ajaxComplete(function() {
                $('body.recent-closings .property-closed-notes').each(function() {

                    // console.log('processing closed text');
        
                    let closing_text = $(this);
                    let parent = $(closing_text).closest('article.elementor-post').find('.elementor-widget-theme-post-featured-image').find('.elementor-widget-container');
        
                    $(this).prependTo( parent );
                });
            });
        }

    });

	/*
	 *
	 *	Place items in here to have them run the page is loaded
	 *
	 */
	$(window).load(function() {});

	/*
	 *
	 *	Place items in here to have them run when the window is scrolled
	 *
	 */
	$(window).scroll(function() {});

	/*
	 *
	 *	Place items in here to have them run when the window is resized
	 *
	 */
	$(window).resize(function() {});

});